import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import IconBase from "./IconBase";
var Envelope = function(props) {
    return /*#__PURE__*/ _jsx(IconBase, _object_spread_props(_object_spread({
        viewBox: "0 0 24 24"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            fill: "currentColor",
            d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM18.4142 6H5.5858L12 11.2115L18.4142 6ZM4 7.28848V18H20V7.28844L12.6306 13.2761C12.2632 13.5746 11.7368 13.5746 11.3694 13.2761L4 7.28848Z"
        })
    }));
};
export default Envelope;
